// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-tab.v-tab.v-btn {
  height: var(--v-tabs-height);
  border-radius: 0;
  min-width: 90px;
}
:where(.vuetify-styles) .v-slide-group--horizontal .v-tab {
  max-width: 360px;
}
:where(.vuetify-styles) .v-slide-group--vertical .v-tab {
  justify-content: start;
}

:where(.vuetify-styles) .v-tab__slider {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background: currentColor;
  pointer-events: none;
  opacity: 0;
}
:where(.vuetify-styles) .v-tab--selected .v-tab__slider {
  opacity: 1;
}
:where(.vuetify-styles) .v-slide-group--vertical .v-tab__slider {
  top: 0;
  height: 100%;
  width: 2px;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-tab--selected.v-btn {
    color: highlight !important;
  }
  :where(.vuetify-styles) .v-tab__slider {
    background: highlight !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTabs/VTab.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,MAAM;EACN,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".v-tab.v-tab.v-btn {\n  height: var(--v-tabs-height);\n  border-radius: 0;\n  min-width: 90px;\n}\n.v-slide-group--horizontal .v-tab {\n  max-width: 360px;\n}\n.v-slide-group--vertical .v-tab {\n  justify-content: start;\n}\n\n.v-tab__slider {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background: currentColor;\n  pointer-events: none;\n  opacity: 0;\n}\n.v-tab--selected .v-tab__slider {\n  opacity: 1;\n}\n.v-slide-group--vertical .v-tab__slider {\n  top: 0;\n  height: 100%;\n  width: 2px;\n}\n\n@media (forced-colors: active) {\n  .v-tab--selected.v-btn {\n    color: highlight !important;\n  }\n  .v-tab__slider {\n    background: highlight !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
